import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Text } from "../../Text/Text";
import "./Option.scss";

const ENTER_KEY = "Enter";

export class Option extends React.Component {
  static propTypes = {
    onClick: PropTypes.func,
    children: PropTypes.node,
    value: PropTypes.any.isRequired,
    id: PropTypes.number,
    className: PropTypes.string,
    selected: PropTypes.bool,
    onUnselectClick: PropTypes.func,
  };

  onClick = (selected, event) => {
    const { onClick } = this.props;
    if (selected) {
      this.onUnselectClick(event);
    } else {
      onClick(event);
    }
  };

  onUnselectClick = (event) => {
    event.stopPropagation();
    const { onUnselectClick, value } = this.props;
    if (onUnselectClick) {
      onUnselectClick(value);
    }
  };

  onKeydownClick = (selected, event) => {
    if (event.key === ENTER_KEY) {
      this.onClick(selected, event);
    }
  };

  render() {
    const { children, className, id, selected, value } = this.props;
    const OptionClass = classNames("Option", { selected }, className);

    return (
      <div
        className={OptionClass}
        id={id}
        value={value}
        onClick={this.onClick.bind(this, selected)}
        onKeyDown={this.onKeydownClick.bind(this, selected)}
        role="button"
        tabIndex={0}
      >
        {!selected ? (
          <Text className="Option__children" type="P" weight="Regular">
            {children}
          </Text>
        ) : (
          <Text
            className="Option__children--selected"
            type="P"
            weight="Regular"
          >
            {children}
          </Text>
        )}
      </div>
    );
  }
}

export default Option;
